import { useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import NotificationButton from "./NotificationButton";
import UserMenu from "./UserMenu";
import { PATHS } from "../../../constants/Paths";

/**
 * App header: current section on the left, notifications + account on the
 * right. The desktop header was previously EMPTY on the left - no title, no
 * breadcrumb - so the bar was sixty-four pixels of nothing.
 */
const SECTION_TITLES = [
  [PATHS.DASHBOARD, "Dashboard"],
  [PATHS.CLIENT_LIST, "Clients"],
  ["/scans/new", "New scan"],
  [PATHS.SCAN_LIST, "Scans"],
  [PATHS.MONITORING, "Monitoring"],
  // Also covers /heartbeat/:accountId - longest-prefix matching below.
  [PATHS.HEARTBEAT, "Heartbeat"],
  [PATHS.REPORTS, "Reports"],
  [PATHS.SUPPORT, "Support"],
  [PATHS.SETTINGS, "Settings"],
  [PATHS.REPGUARD_INSTALL, "RepGuard"],
  [PATHS.ADMIN, "Admin"],
  [PATHS.GLOBAL_ADMIN, "Global Admin"],
  [PATHS.ONBOARDING, "Setup"],
];

function sectionTitle(pathname) {
  // Longest matching prefix wins so /scans/new beats /scans.
  const match = SECTION_TITLES
    .filter(([p]) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p))
    .sort((x, y) => y[0].length - x[0].length)[0];
  return match ? match[1] : "";
}

export default function DashboardHeader({ onMenuClick }) {
  const location = useLocation();
  const title = sectionTitle(location.pathname);

  return (
    <header className="flex items-center justify-between gap-3 px-4 sm:px-8 border-b border-border bg-card h-16">
      <div className="flex min-w-0 items-center gap-2">
        {onMenuClick && (
          <button
            onClick={onMenuClick}
            className="md:hidden inline-flex flex-shrink-0 items-center justify-center rounded-lg p-2 text-foreground hover:bg-muted"
            aria-label="Open menu"
          >
            <Menu className="h-5 w-5" />
          </button>
        )}
        <span className="md:hidden font-semibold text-foreground">RepCheck</span>
        {title && (
          <span className="hidden md:inline text-sm font-medium text-muted-foreground">{title}</span>
        )}
      </div>
      <div className="flex flex-shrink-0 items-center gap-1 sm:gap-3">
        <NotificationButton />
        <UserMenu />
      </div>
    </header>
  );
}
